
export default populateIdentifierReplacements;
import hasOwnProp from 'utils/hasOwnProp';
import topLevelScopeConflicts from './topLevelScopeConflicts';

/**
 * Figures out which identifiers need to be rewritten within
   a bundle to avoid conflicts
 * @param {object} bundle - the bundle
 * @returns {object}
 */
function populateIdentifierReplacements(bundle) {
	// first, discover conflicts
	var conflicts = topLevelScopeConflicts(bundle);

	// then figure out what identifiers need to be created
	// for default exports
	bundle.modules.forEach(function (mod) {
		var x = mod.defaultExport;

		if (x) {
			var result = undefined;

			if (x.hasDeclaration && x.name) {
				result = hasOwnProp.call(conflicts, x.name) || otherModulesDeclare(mod, x.name) ? mod.name + '__' + x.name : x.name;
			} else {
				result = hasOwnProp.call(conflicts, mod.name) || x.value !== mod.name && ~mod.ast._topLevelNames.indexOf(mod.name) || otherModulesDeclare(mod, mod.name) ? mod.name + '__default' : mod.name;
			}

			mod.identifierReplacements['default'] = result;
		}
	});

	// then determine which existing identifiers
	// need to be replaced
	bundle.modules.forEach(function (mod) {
		var moduleIdentifiers = mod.identifierReplacements;

		mod.ast._topLevelNames.forEach(function (n) {
			moduleIdentifiers[n] = hasOwnProp.call(conflicts, n) ? mod.name + '__' + n : n;
		});

		mod.imports.forEach(function (x) {
			if (x.passthrough) {
				return;
			}

			var imported = x.module;

			x.specifiers.forEach(function (s) {
				var replacement = undefined;

				if (s.isBatch) {
					replacement = x.module.name;
				} else {
					var _mod = undefined;
					var specifierName = undefined;

					if (s.origin) {
						// chained bindings
						_mod = s.origin.module;
						specifierName = s.origin.name;
					} else {
						_mod = imported;
						specifierName = s.name;
					}

					var moduleName = _mod && _mod.name;

					if (specifierName === 'default') {
						// if it's an external module, always use __default if the
						// bundle also uses named imports
						if (imported.isExternal) {
							replacement = imported.needsNamed ? moduleName + '__default' : moduleName;
						}

						// TODO We currently need to check for the existence of `mod`, because modules
						// can be skipped. Would be better to replace skipped modules with dummies
						// - see https://github.com/Rich-Harris/esperanto/issues/32
						else if (_mod && !_mod.isSkipped) {
								replacement = _mod.identifierReplacements['default'];
							}
					} else if (!imported.isExternal) {
						replacement = hasOwnProp.call(conflicts, specifierName) ? moduleName + '__' + specifierName : specifierName;
					} else {
						replacement = moduleName + '.' + specifierName;
					}
				}

				if (replacement !== s.as) {
					moduleIdentifiers[s.as] = replacement;
				}
			});
		});
	});

	function otherModulesDeclare(mod, replacement) {
		var i, otherMod;

		i = bundle.modules.length;
		while (i--) {
			otherMod = bundle.modules[i];

			if (mod === otherMod) {
				continue;
			}

			if (hasOwnProp.call(otherMod.ast._declared, replacement)) {
				return true;
			}
		}
	}
}
//# sourceMappingURL=/www/ESPERANTO/esperanto/.gobble-build/01-babel/1/bundler/combine/populateIdentifierReplacements.js.01-babel.map